import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../shared';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {

  constructor(private userService: UserService,private translate: TranslateService) { 
    this.translate.setDefaultLang(userService.defaultLang);
  }

  ngOnInit() {
  }

}
